// extracted by mini-css-extract-plugin
export default {"Advantages":"Advantages_Advantages__serZ1","holder":"Advantages_holder__GulYa","item":"Advantages_item__BNtSx","title":"Advantages_title__zfyXD"};